import React from "react";
import swal from "sweetalert";

function DeleteClienteButton({ id, deleteCliente, setClientes }) {
  function confirmDelete(id) {
    swal({
      title: "Eliminar Cliente?",
      icon: "error",
      buttons: {
        cancel: "Cancelar",
        catch: "Eliminar",
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteCliente(id).then(() => {
          swal("Cliente eliminado", {
            button: false,
            icon: "success",
            timer: "1500",
          });
          setClientes((prevState) =>
            prevState.filter((cliente) => cliente.id !== id)
          );
        });
      }
    });
  }

  return (
    <button
      className="btn btn-danger btn-sm btn-block m-1"
      onClick={() => confirmDelete(id)}
    >
      Eliminar
    </button>
  );
}

export default DeleteClienteButton;
